<div class="badge">
  <ng-content select="[badge-left]" />
  <ng-content></ng-content>
  <ng-content select="[badge-right]" />
</div>
